import Radio from 'backbone.radio';
import RemoveCollaboratorDialog from '@/views/dialogs/remove_collaborator';
import RemoveCollaboratorWithDevicesDialog from '@/views/dialogs/remove_collaborator_with_devices';

    var globalCh = Radio.channel('global');

    function show_remove_collaborator_dialog(targetAccount, collaborator) {
        var view;
        var collaborator_devices = targetAccount.devices.where({ owned_by: collaborator.id });

        if (collaborator_devices.length > 0) {
            view = new RemoveCollaboratorWithDevicesDialog({
                model: collaborator,
                targetAccount: targetAccount,
                devices: collaborator_devices,
            });
        } else {
            view = new RemoveCollaboratorDialog({
                model: collaborator,
                targetAccount: targetAccount
            });
        }

        globalCh.request('showDialog', view);
    }

    export default show_remove_collaborator_dialog;

